const UNDEFINED_VALUE_STRING = "unknown";

export function getWikiId(): string | number {
  return window.RLCONF?.wgCityId ?? UNDEFINED_VALUE_STRING;
}
